export const getErrorPayload = (error) => ({
  status: error.response?.status ?? 500,
  message:
    error.response?.data?.message ||
    error.response?.data?.title ||
    error.message ||
    "Something went wrong.",
  data: error.response?.data ?? null,
});
